export function RneMask(): string {
  return 'AAAAAAA-A';
}
